import http from "config/http";
import { ListVolunteersRequest, ListVolunteersResponse } from "./listVolunteers";

const exportListVolunteers = ({ projectSlug, ...data }: ListVolunteersRequest) => {
  return http.post<ListVolunteersResponse>(`/projects/${projectSlug}/export-all-volunteers`, data);
};

export default exportListVolunteers;
